import { Outlet } from "react-router";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { UnauthorizedMessage } from "../../shared/components";
import { useEvalStewardEnabled } from "../hooks";
import styles from "./EvalStewardLayout.module.css";

export function EvalStewardLayout() {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  if (!isEvalStewardEnabled) {
    return (
      <WorkspaceScreen>
        <UnauthorizedMessage />
      </WorkspaceScreen>
    );
  }

  return (
    <WorkspaceScreen wide>
      <div className={styles.container} data-testid="eval-steward-container">
        <Outlet />
      </div>
    </WorkspaceScreen>
  );
}
